/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2a645ece8733
 */

import * as z from "zod";

export type GenerateArchiveResponse = {
  asset_id?: string | undefined;
  public_id?: string | undefined;
  version?: number | undefined;
  version_id?: string | undefined;
  signature?: string | undefined;
  resource_type?: string | undefined;
  created_at?: string | undefined;
  tags?: Array<string> | null | undefined;
  bytes?: number | undefined;
  type?: string | undefined;
  etag?: string | undefined;
  placeholder?: boolean | undefined;
  url?: string | undefined;
  secure_url?: string | undefined;
  folder?: string | undefined;
  resource_count?: number | undefined;
  file_count?: number | undefined;
  asset_folder?: string | undefined;
  display_name?: string | undefined;
  missing_public_ids?: Array<string> | undefined;
  empty_tags?: Array<string> | undefined;
  empty_prefixes?: Array<string> | undefined;
};

export const GenerateArchiveResponse$zodSchema: z.ZodType<
  GenerateArchiveResponse
> = z.object({
  asset_folder: z.string().optional().describe(
    "The folder in your product environment where the archive is stored.",
  ),
  asset_id: z.string().optional().describe(
    "A 32-character hexadecimal asset ID.",
  ),
  bytes: z.int().optional().describe(
    "The size of the generated archive in bytes.",
  ),
  created_at: z.iso.datetime({ offset: true }).optional().describe(
    "The timestamp when the archive was generated.",
  ),
  display_name: z.string().optional().describe(
    "The display name of the generated archive.",
  ),
  empty_prefixes: z.array(z.string()).optional().describe(
    "The list of prefixes that were requested but returned no results.",
  ),
  empty_tags: z.array(z.string()).optional().describe(
    "The list of tags that were requested but returned no results.",
  ),
  etag: z.string().optional().describe("The ETag of the generated archive."),
  file_count: z.int().optional().describe(
    "The total number of files in the archive.",
  ),
  folder: z.string().optional().describe(
    "The folder where the archive is stored (only for product environments with Dynamic Folders disabled).",
  ),
  missing_public_ids: z.array(z.string()).optional().describe(
    "The list of public IDs that were requested but not found.",
  ),
  placeholder: z.boolean().optional().describe(
    "Whether the generated archive is a placeholder.",
  ),
  public_id: z.string().optional().describe(
    "The public ID of the generated archive.",
  ),
  resource_count: z.int().optional().describe(
    "The number of unique resources included in the archive.",
  ),
  resource_type: z.string().optional().describe(
    "The type of resource. Always \"raw\" for generated archives.",
  ),
  secure_url: z.string().optional().describe(
    "The HTTPS URL for downloading the generated archive.",
  ),
  signature: z.string().optional().describe(
    "The API signature for the generated archive.",
  ),
  tags: z.array(z.string()).nullable().optional().describe(
    "Tag names assigned to the asset.",
  ),
  type: z.string().optional().describe(
    "The resource type of the generated archive.",
  ),
  url: z.string().optional().describe(
    "The HTTP URL for downloading the generated archive.",
  ),
  version: z.int().optional().describe(
    "The version number of the generated archive.",
  ),
  version_id: z.string().optional().describe(
    "Hexadecimal version ID; length is a positive multiple of 32 (typically 32 or 64).",
  ),
});
